import { map, Observable, tap } from 'rxjs';
import { GameApplicationsService } from '@games/infra';
import { inject } from '@angular/core';
import { CreatedGamePlayerApplicationDto, SendPlayerApplicationPathParams } from '@core-http';
import { SendApplicationCommandResult } from './send-application.command-result';
import { AppsFlyerService } from '@core';

export class SendApplicationCommandHandler {
  private readonly gameApplicationsService: GameApplicationsService = inject(GameApplicationsService);
  private readonly appsFlyerService: AppsFlyerService = inject(AppsFlyerService);

  sendApplication(gameId: string): Observable<SendApplicationCommandResult> {
    const pathParams: SendPlayerApplicationPathParams = { gameId };

    return this.gameApplicationsService.sendApplication(pathParams).pipe(
      map(
        (dto: CreatedGamePlayerApplicationDto): SendApplicationCommandResult => ({
          gamePlayerApplicationId: dto.gamePlayerApplicationId,
          autoApproved: dto.autoApproved
        })
      ),
      tap(() => {
        this.appsFlyerService.logEvent('fb_joingame');
      })
    );
  }
}
